import { render } from "./ScanPage.vue?vue&type=template&id=1f2ef7a4&scoped=true"
import script from "./ScanPage.vue?vue&type=script&lang=js"
export * from "./ScanPage.vue?vue&type=script&lang=js"

import "./ScanPage.vue?vue&type=style&index=0&id=1f2ef7a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2ef7a4"]])

export default __exports__